module.exports = __webpack_public_path__ + "7010821cc85b17436d81de3062f45510.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/relic_0.jpg
// module id = 172
// module chunks = 0